import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IstDatePipe } from '@edtech-ui/core/models/Classroom/ist-date.pipe';
import { TeacherOnBoardPayload } from '@edtech-ui/core/models/interfaces/invite-teacher-on-board';
import { TeacherOnBoardInvitation } from '@edtech-ui/core/models/interfaces/student-dashboard/get-onBoard-invite';
import { AdminService } from '@edtech-ui/core/services/admin-dashboard/admin.service';
import { AuthServiceService } from '@edtech-ui/core/services/authService/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, of, Subscription, tap } from 'rxjs';

@Component({
	selector: 'app-teachers-invite',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, FormsModule, IstDatePipe],
	templateUrl: './teachers-invite.component.html',
	styleUrl: './teachers-invite.component.scss'
})
export class TeachersInviteComponent implements OnInit ,OnDestroy {

	teacherInviteForm: FormGroup;
	subscription = new Subscription();
	emailsToInvite: string[] = [];
	inviteTeacherOnBoard :TeacherOnBoardInvitation[]=[];
	totalTeachersCount!:number;
	isInviting:boolean =false;

	constructor(
		private _authService: AuthServiceService,
		private _toastr: ToastrService,
		private _adminService:AdminService,
	) {
		this.teacherInviteForm = new FormGroup({
			teacher_emails: new FormControl('', [Validators.required, Validators.email])
		});
	}

	ngOnInit(): void {
		this.getTeacherOnBoard();
	}

	inviteTeacher() {

		if (this.emailsToInvite.length === 0) {
			this._toastr.warning('Please add at least one email');
			return;
		}

		this.isInviting = true;
		const payload: TeacherOnBoardPayload = { teacher_emails: this.emailsToInvite };
		this.subscription.add(
			this._authService.postSentTeacherInvite(payload).pipe(
				tap(response => {
					if (response.Success) {
						this.isInviting = false;
						this._toastr.success(response.Message);
						this.emailsToInvite = [];
					} else {
						this._toastr.error(response.Message);
						this.isInviting = false;
					}
				}),
				catchError(err => {
					this.isInviting = false;
					this._toastr.error('Something went wrong while joining the class');
					return of(null);
				})
			).subscribe()
		);

	}

	addEmail() {
		const email = this.teacherInviteForm.value.teacher_emails?.trim();
		if (email && this.teacherInviteForm.controls['teacher_emails'].valid) {
			if (!this.emailsToInvite.includes(email)) {
				this.emailsToInvite.push(email);
			} else {
				this._toastr.info('Email already added');
			}
			this.teacherInviteForm.reset();
		} else {
			this._toastr.warning('Enter a valid email');
		}
	}


	getTeacherOnBoard(){
		this._adminService.getAdminTeacherInvite().pipe(
			tap(response=>{
				if(response.Success){
					this.inviteTeacherOnBoard = response.Data.invitations;
					this.totalTeachersCount = response.Data.total_count;
				}
			})
		)
		
		.subscribe();
	}

ngOnDestroy(): void {
	
}
	invitedTeachers = [
		{
			name: 'tejaswini',
			email: 'tejaswini@school.edu',
			invitedOn: 'Jan 15, 2024',
			status: 'Onboarded'
		},
		{
			name: 'kruthika',
			email: 'kruthika.edu',
			invitedOn: 'Jan 14, 2024',
			status: 'Pending'
		},
		{
			name: 'nikita',
			email: 'nikita',
			invitedOn: 'Jan 13, 2024',
			status: 'Onboarded'
		},
		{
			name: 'nisarga',
			email: 'nisarga',
			invitedOn: 'Jan 12, 2024',
			status: 'Pending'
		},
		{
			name: 'meghana',
			email: 'meghana',
			invitedOn: 'Jan 12, 2024',
			status: 'Pending'
		}
	];
}
